module.exports = __webpack_public_path__ + "static/freescantrio98lines-bdbf8e9296db18c40e065fcf4e5be7b6.jpg";